import 'apps/pathways/styles/start.scss';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import { Route, Redirect, Switch, Link, NavLink } from 'library/util/core-router';
import ScrollAnimation from 'library/util/scroll';
import loadGraphData from 'util/hoc/with-data';
import withUser from 'util/hoc/with-user';
import withConfig from 'util/hoc/with-config';
import PathwayEditBar from 'apps/pathways/components/pathways-edit-bar';
import ScrollOnMount from 'library/components/scroll-on-mount';
import PathwaysFooter from 'apps/pathways/components/pathways-footer';

import StartStepZeroHeader from 'apps/pathways/app/start/headers/zero';
import StartStepOneHeader from 'apps/pathways/app/start/headers/one';
import StartStepTwoHeader from 'apps/pathways/app/start/headers/two';
import StartStepThreeHeader from 'apps/pathways/app/start/headers/three';
import StartStepFourHeader from 'apps/pathways/app/start/headers/four';

import DownArrow from 'apps/pathways/components/down-arrow';

const TempStep = () => (
  <div style={{height: '200vh', width: '100vw'}}>

  </div>
);

import SignupStepZero from 'apps/pathways/app/start/steps/zero';
import SignupStepOne from 'apps/pathways/app/start/steps/one';
import SignupStepTwo from 'apps/pathways/app/start/steps/two';
import SignupStepThree from 'apps/pathways/app/start/steps/three';
import SignupStepFour from 'apps/pathways/app/start/steps/four';

const STEPS = [
  {
    headerComponent: StartStepZeroHeader,
    component: SignupStepZero,
    label: 'Overview',
    key: 'overview'
  },
  {
    headerComponent: StartStepOneHeader,
    component: withUser(loadGraphData(SignupStepOne, __LANGUAGE__)),
    label: 'Experience',
    key: 'experience'
  },
  {
    headerComponent: StartStepTwoHeader,
    component: loadGraphData(SignupStepTwo, __LANGUAGE__),
    label: 'Soft Skills',
    key: 'soft-skills'
  },
  {
    headerComponent: StartStepThreeHeader,
    component: loadGraphData(SignupStepThree, __LANGUAGE__),
    label: 'Preferences',
    key: 'preferences'
  },
  {
    headerComponent: StartStepFourHeader,
    component: loadGraphData(SignupStepFour, __LANGUAGE__, 300),
    label: 'Results',
    key: 'results'
  }
];

class StartMain extends React.Component {
  static propTypes = {
    match: PropTypes.object,
    pathway: PropTypes.object,
    refreshPathway: PropTypes.func,
    configuration: PropTypes.object
  }

  startY = null;
  handleStickyScroll = () => {
    if (window.scrollY > window.innerHeight || this.isScrolling) {
      clearTimeout(this.stickyScrollTimeout);
      return;
    }

    if (this.stickyScrollTimeout) {
      clearTimeout(this.stickyScrollTimeout);
    }

    this.stickyScrollTimeout = setTimeout(()=>{
      const scrollTop = window.scrollY;

      const halfHeight    = window.innerHeight / 2;
      const quarterHeight = halfHeight / 2;

      if (scrollTop < quarterHeight || scrollTop > (halfHeight + quarterHeight)) return;

      const dest = scrollTop < (window.innerHeight / 2) ? window.innerHeight : 0;
      const scrollTime = 250;

      if (scrollTime !== 0) {
        this.isScrolling = true;
        new ScrollAnimation(scrollTop, dest, scrollTime, 'quad.easeInOut', window, ()=>{
          this.isScrolling = false;
        });
      }

      clearTimeout(this.stickyScrollTimeout);
    }, 1000/30);
  }

  componentWillMount() {
    //NOTE: Disabled till i can get the experience right
    // window.addEventListener('scroll', this.handleStickyScroll, window.passiveSupported ? { passive: true } : false);
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.handleStickyScroll);
  }

  render() {
    const {
      match,
      pathway,
      refreshPathway,
      configuration
    } = this.props;

    const step = Number(resolve(match, 'params/step', 0));

    const disabledSteps = resolve(configuration, 'apps/pathways/configuration/disabledSteps', {});
    const stepsConfig = resolve(configuration, 'apps/pathways/configuration/onboarding_steps', {});
    const stepsOrder = resolve(configuration, 'apps/pathways/configuration/onboarding_order', []);
    const Steps = STEPS.filter(({ key })=>!disabledSteps[key]).sort((a,b)=>(
      stepsOrder.indexOf(String(a.key)) - stepsOrder.indexOf(String(b.key))
    )).map(s=>(
      {
        ...s,
        ...resolve(stepsConfig, s.key, {})
      }
    ));

    if (!Steps[step]) {
      return <Redirect to="/pathways/start/0" />
    }

    return (
      <div className="pathways-start">
        {
          [step].map((v)=><ScrollOnMount key={v} />)
        }
        <div className="pathways-start-header">
          {
            Steps[step].key != 'overview'
              ? (
                <div className="pathways-start-header-number">
                  { step + (Steps[0] === 'overview' ? 0 : 1) }
                </div>
              )
              : null
          }
          {
            pathway || resolve(configuration, 'apps/pathways/configuration/edit_bar/show', false)
              ? (
                <PathwayEditBar refreshPathway={refreshPathway} pathway={resolve(configuration, 'apps/pathways/configuration/pathway', true)?pathway:null}>
                  {
                    Steps.map((s,i)=>(
                      <NavLink
                        key={i}
                        to={`/pathways/start/${i}`}
                      >
                        { `${resolve(s, `label`, '')}` }
                      </NavLink>
                    ))
                  }
                </PathwayEditBar>
              )
              : (
                <div className="pathways-start-header-controls">
                  {
                    resolve(Steps, `${step-1}/label`, false)
                      ? <Link to={`/pathways/start/${step-1}`}>{ `< ${resolve(Steps, `${step-1}/label`, '')}` }</Link>
                      : <span />
                  }
                  {
                    resolve(Steps, `${step+1}/label`, false)
                      ? <Link to={`/pathways/start/${step+1}`}>{ `${resolve(Steps, `${step+1}/label`, '')} >` }</Link>
                      : <span />
                  }
                </div>
              )
          }
          <div className="pathways-start-header-body">
            <Switch>
              <Route
                exact
                path={`/pathways/start`}
                render={(props) => {
                  const C = Steps[0].headerComponent;
                  return <C {...props} step={0} />;
                }}
              />
              {
                Steps.map(({headerComponent:Component},i)=>(
                  <Route
                    key={i}
                    path={`/pathways/start/${i}`}
                    render={(props) => (
                      <Component {...props} step={i} />
                    )}
                  />
                ))
              }
            </Switch>
          </div>
          <div className="pathways-start-header-footer">
            {
              step > 0 && step !== Steps.length-1
                ? <Link to={`/pathways/start/${step+1}`}>skip</Link>
                : null
            }
            <DownArrow />
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`/pathways/start`}
            render={(props) => {
              const C = Steps[0].component;
              return <C {...props} step={0} />;
            }}
          />
          {
            Steps.map(({component:Component}, i)=>(
              <Route
                key={i}
                path={`/pathways/start/${i}`}
                render={(props) => (
                  <Component {...props} step={i} />
                )}
              />
            ))
          }
          <Redirect to="/pathways/start" />
        </Switch>
        <PathwaysFooter />
      </div>
    );
  }
}

export default withConfig(StartMain);
